import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2BulkReviewParams,
  IIndirectTaxFilingV2BulkReviewResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function bulkReviewIndirectTaxFilingsV2({
  params,
}: {
  params: IIndirectTaxFilingV2BulkReviewParams;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2BulkReviewResponse>
> {
  try {
    const response = await fetcher(
      'new-sales-tax/filings-v2/review/bulk',
      { method: 'POST', body: params }
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to mark filings as reviewed',
      };
    }
    const data: IIndirectTaxFilingV2BulkReviewResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to mark filings as reviewed',
    };
  }
}
